import type { ReactNode } from "react"

import { NavigationItemBase } from "@/domains/navigation/navigation-item"

// Available complex breadcrumb applications
export type ComplexBreadcrumbApplicationType =
  | "analytics-pages"
  | "classic-liquidity-pages"
  | "cl-farms-pages"
  | "lock-home"
  | "lock-pages"
  | "manual-cl-v1-manage-pages"
  | "manual-cl-v1-position"
  | "manual-cl-v2-manage-pages"
  | "manual-cl-v2-position"
  | "rewards-pages"

// Complex breadcrumb item interface
export interface ComplexBreadcrumbItem {
  readonly type: "complex"
  readonly application: ComplexBreadcrumbApplicationType
  readonly render: () => ReactNode
}

// Convenience type for creating complex items directly
export type ComplexBreadcrumbItemConfig = Omit<ComplexBreadcrumbItem, "type">

// Union type for all breadcrumb items
export type BreadcrumbItem = NavigationItemBase | ComplexBreadcrumbItem

// Type guard to check if item is complex
export function isComplexBreadcrumbItem(item: BreadcrumbItem): item is ComplexBreadcrumbItem {
  return "type" in item && item.type === "complex"
}
